import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// BIBLIOTECA DATE-FNS
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns-tz';
import { startOfDay, startOfYear } from 'date-fns';

// ESTILIZAÇÃO
import {
  Backdrop,
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  Collapse,
  Container,
  Divider,
  Fade,
  Grid,
  List,
  ListItem,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core/';
import { NavigateBefore } from '@material-ui/icons';
import { useStyles } from './style';

// COMPONENTS
import { IncFilterOpsType } from '../../components/FilterBar';
import MapMarker from '../../components/MapMarker';
import TableRegister from '../../components/TableRegister';
import DialogWarnActionsDuplicity, {
  DialogActionType,
} from '../../components/DialogWarnActionsDuplicity';

// SERVIÇOS
import { Agent, MissionCar, RecordsResponseType } from '../../@types/records';
import api from '../../services/api';
import { DriverIncidenteDetailsType } from '../../@types/records';
import { toDate } from '../../utils/formatDate';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import Colors from '../../components/Colors';
import DialogWarningMessage from '../../components/DialogWarningMessage';

interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}
interface Vehicle {
  Categoria: string;
  Cor: string;
  'Código Veículo': string;
  Espécie: string;
  Manobra: string;
  Danificado: string;
  'Formulario de Dano': damageFormData;
  'Tipo Veículo': string;
  Aluguel: string;
  Marca: string;
  'Número do Ônibus': string;
  Placa: string;
  'Ano Fabricação': string;
  Legalizado: string;
  _localId: string;
  'Linha do Ônibus': string;
  'Outra manobra': string;
  'Via de Acesso': string;
}
interface Street {
  'Condição da Calçada': string;
  Nome: string;
  'Sinalização Vertical': string;
  'Condição da Pista': string;
  'Sinalização Horizontal': string;
  'Faixa para Sentido': string;
  'Alinhamento Vertical': string;
  'Obra de Arte': string;
  'Tipo do Pavimento': string;
  _localId: string;
  'Alinhamento Horizontal': string;
  'Separação Central': string;
  'Tipo da Pista': string;
  'Obras na Pista': string;
}
interface damageItem {
  label: string;
  answer: string;
}
interface damageFormData {
  DamageType: string;
  structure: string;
  DamageFormDetails: damageItem[];
}
interface Victim {
  'Usava Cinto ou Capacete': string;
  'Data de Alta': string;
  Nome: string;
  'Data de Internação': string;
  'Categoria do Condutor': string;
  'Tipo de Morte': string;
  'Início de Reabilitação': string;
  'Grau de Instrução': string;
  Encaminhamento: string;
  'Tipo de Pessoa': string;
  'Orgão Emissor': string;
  Endereço: string;
  Sexo: string;
  Idade: string;
  'Situação do Condutor': string;
  'Primeira CNH': string;
  'Exame de alcoolemia': string;
  Observações: string;
  'Motivo da Viagem': string;
  Dosagem: string;
  'Situação ou Vínculo': string;
  'Código Veículo': string;
  'Possui Deficiência': string;
  'Nome do Pai': string;
  'Posição do Passageiro': string;
  Profissão: string;
  'Data de Nascimento': string;
  'Número Documento': string;
  'Número do cartão de saúde cidadão': string;
  'Data da Óbito': string;
  'Proprietário do Veículo': string;
  'Estado Civil': string;
  'Número da CNH': string;
  'Tipo Documento': string;
  'Procedimentos realizados': string;
  'Removido por': string;
  Lesões: string[];
  'Evolução de Caso': string;
  'Fim da Reabilitação': string;
  'Gravidade da Lesão': string;
  'Custo Geral': string;
  _localId: string;
  Etnia: string;
  'Nome da Mãe': string;
  'Validade da CNH': string;
}
interface IncidentDetails {
  'Superfície da Pista': string;
  Local: string;
  Natureza: string;
  Jurisdição: string;
  Tempo: string;
  'Hora informada': string;
  Severidade: string;
  'Endereço 1': string;
  'Controle de Tráfego': string;
  Interseção: string;
  Iluminação: string;
  'Endereço 2': string;
}
interface Register {
  uuid: '';
  data: {
    driverVeiculo: Vehicle[];
    driverVia: Street[];
    driverVitima: Victim[];
    driverIncidenteDetails: DriverIncidenteDetailsType;
    driverAgentsAndVehicles: {
      agents: Agent[];
      missionCars: MissionCar[];
    };
  };
  geom: {
    coordinates: number[];
  };
  modified_by: string;
  created: string;
  modified: string;
  occurred_from: string;
  location_text: string;
}

interface IncidentImages {
  path: string;
  uuid: string;
  description: string;
}

interface Fonte {
  tipo: string;
  codigo: string;
}

const AnalyzeDuplicity: React.FC = () => {
  const initialRecordsResponse: RecordsResponseType = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };

  const styles = useStyles();
  const { pathId, pathIdB } = useParams<{ pathId: string; pathIdB: string }>();
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [imagens, setImagens] = useState<IncidentImages[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingDate, setloadingDate] = useState<boolean>(true);

  const [active, setActive] = useState<number>(0);
  const [variant, setVariant] = useState<'text' | 'outlined' | 'contained' | undefined>(
    'text',
  );
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [open, setOpen] = React.useState(false);
  const [street, setStreet] = useState<Street[]>([]);
  const [victim, setVictim] = useState<Victim[]>([]);
  const [fontes, setFontes] = useState<Fonte[]>([]);
  const [fontesB, setFontesB] = useState<Fonte[]>([]);
  const [damageFormColapseControl, setDamageFormColapseControl] = useState<boolean>(
    false,
  );
  const [register, setRegister] = useState<Register>({
    uuid: '',
    data: {
      driverVeiculo: vehicles,
      driverVia: street,
      driverVitima: victim,
      driverIncidenteDetails: {
        'Superfície da Pista': '',
        Local: '',
        Natureza: '',
        Jurisdição: '',
        Tempo: '',
        'Hora informada': '',
        Severidade: '',
        'Endereço 1': '',
        'Controle de Tráfego': '',
        Interseção: '',
        Iluminação: '',
        'Endereço 2': '',
        'Código do Acidente': '',
        'Elementos Atingidas': '',
        'Ocorrido ao Longo da Via/Cruzamento': '',
        'Primeira Fonte de Informação': '',
        'Tipo de Cruzamento': '',
      },
      driverAgentsAndVehicles: {
        agents: [],
        missionCars: [],
      },
    },
    geom: {
      coordinates: [0, 0],
    },
    modified_by: '',
    created: '',
    modified: '',
    occurred_from: '',
    location_text: '',
  });
  const [registerB, setRegisterB] = useState<Register>({
    uuid: '',
    data: {
      driverVeiculo: vehicles,
      driverVia: street,
      driverVitima: victim,
      driverIncidenteDetails: {
        'Superfície da Pista': '',
        Local: '',
        Natureza: '',
        Jurisdição: '',
        Tempo: '',
        'Hora informada': '',
        Severidade: '',
        'Endereço 1': '',
        'Controle de Tráfego': '',
        Interseção: '',
        Iluminação: '',
        'Endereço 2': '',
        'Código do Acidente': '',
        'Elementos Atingidas': '',
        'Ocorrido ao Longo da Via/Cruzamento': '',
        'Primeira Fonte de Informação': '',
        'Tipo de Cruzamento': '',
      },
      driverAgentsAndVehicles: {
        agents: [],
        missionCars: [],
      },
    },
    geom: {
      coordinates: [0, 0],
    },
    modified_by: '',
    created: '',
    modified: '',
    occurred_from: '',
    location_text: '',
  });
  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');

  const [records, setRecords] = useState<RecordsResponseType>(initialRecordsResponse);

  const customTableStyles = {
    width: '100%',
  };

  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [dateMin, setDateMin] = useState<string>(
    `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`,
  );
  const [dateMax, setDateMax] = useState<string>(
    `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`,
  );
  // Armazenando todos os Jsonb carregados na variavel jsonb
  const [pageOffset, setPageOffset] = useState<number>(0);
  
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const arrayImagens = useCallback(async () => {
    const { data: file } = await api.get<IncidentImages[]>(
      '/api/incident_records/get_images/',
      {
        headers: authHeader,
        params: {
          recordID: pathId,
        },
      },
    );
    setImagens(file);
  }, [authHeader, pathId]);

  const history = useHistory();
  const navigate = (path: string) => {
    history.push(path);
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get<RecordsResponseType>(
      `/api/incident_records/duplicidades/${pathId}/`,

      {
        headers: { Authorization: `Token ${localStorage.getItem('auth')}` },

        // params: {
        //   limit: rowsPerPage,
        //   occurred_min: format(
        //     startOfDay(new Date(filterOps.startDate || dateMin)),
        //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        //   ),
        //   occurred_max: filterOps.endDate || dateMax,
        //   offset: pageOffset,
        // },
      },
    );

    console.log(data);

    setRecords(data);
    setLoading(false);
  }, [
    rowsPerPage,
    dateMin,
    dateMax,
    pageOffset,
  ]);

  const [dialogAction, setDialogAction] = useState<DialogActionType>({
    open: false,
    title: '',
    actions: [],
  });

  const [openDialog, setOpenDialog] = useState(false);

  // SINISTROS DIFERENTERS
  const differentIncidents = async () => {
    setLoading(true);
    try {
      const { data, status } = await api.put(
        `/api/incident_records/resolve_duplicity/`,
        {
          incident_with_duplicity: register,
          incident_being_compared: registerB,
          solution: 'diferentes',
        },
        { headers: authHeader },
      );
      setLoading(false);

      if (data.has_dups) {
        setDialogAction({
          open: true,
          title: data.message,
          subtitle: 'Porém, ainda há duplicidades',
          actions: [
            {
              btnText: 'Voltar',
              action: () => navigate(`/registros/duplicidades/${pathId}`),
              color: 'primary',
            },
            {
              btnText: 'Lista de duplicidades',
              action: () => navigate(`/duplicidades`),
              color: 'primary',
            },
          ],
        });
        return;
      }

      setDialogAction({
        open: true,
        title: data.message,
        actions: [
          {
            btnText: 'Duplicidades',
            action: () => navigate(`/duplicidades`),
            color: 'primary',
          },
        ],
      });
    } catch (error) {
      // TODO: COLOCAR A MENSAGEM DE ERRO
      setLoading(false);
      setSnackbar({
        open: true,
        message: 'Erro ao atualizar duplicidade!',
      });
    }
  };

  // TODO: Terminar isso aqui
  function getCodigos(
    driverIncidente: any,
    setFontesLocal: React.Dispatch<React.SetStateAction<Fonte[]>>,
  ) {
    const codigoKeys = Object.keys(driverIncidente).filter(
      (key) =>
        key.includes('Código') &&
        driverIncidente[key] !== '' &&
        key !== 'Código do Acidente',
    );
    console.log(codigoKeys);
    const listaObjetos: Fonte[] = codigoKeys.map((key) => {
      const tipo = key.split('Código ')[1];
      const codigo = driverIncidente[key];
      return { tipo, codigo };
    });

    setFontesLocal(listaObjetos);
  }

  // Path A
  useEffect(() => {
    async function loadRegister(id: string) {
      setLoading(true);
      const groups = localStorage.getItem('groups')?.split(' ');
      if (groups) {
        groups.forEach((gr: string) => {
          if (gr === 'public') {
            setPublicGroup(true);
          } else if (gr === 'digitador') {
            setTypist(true);
          } else if (gr === 'tec_engenharia') {
            setTecEng(true);
          } else if (gr === 'geofi') {
            setGeofi(true);
          } else if (gr === 'admin') {
            setAdmin(true);
          }
        });
      }

      const registers = await api.get(`/api/incident_records/${pathId}}/`, {
        headers: authHeader,
        params: {
          record_type: process.env.REACT_APP_INC_RECORD_TYPE,
          details_only:
            (geofi || publicGroup || tecEng) && !(admin || typist) ? 'True' : 'False',
        },
      });

      setRegister(registers.data);
      console.log(registers.data);
      getCodigos(registers.data.data.driverIncidenteDetails, setFontes);
    }
    loadRegister(pathId);
    arrayImagens();
    fetchData();

    if (register.created !== '') {
      setLoading(false);
    }
  }, [
    pathId,
    authHeader,
    admin,
    register.created,
    geofi,
    publicGroup,
    tecEng,
    typist,
    arrayImagens,
  ]);

  // Path B
  useEffect(() => {
    async function loadRegister(id: string) {
      setLoading(true);
      const groups = localStorage.getItem('groups')?.split(' ');
      if (groups) {
        groups.forEach((gr: string) => {
          if (gr === 'public') {
            setPublicGroup(true);
          } else if (gr === 'digitador') {
            setTypist(true);
          } else if (gr === 'tec_engenharia') {
            setTecEng(true);
          } else if (gr === 'geofi') {
            setGeofi(true);
          } else if (gr === 'admin') {
            setAdmin(true);
          }
        });
      }

      const registers = await api.get(`/api/incident_records/${id}}/`, {
        headers: authHeader,
        params: {
          record_type: process.env.REACT_APP_INC_RECORD_TYPE,
          details_only:
            (geofi || publicGroup || tecEng) && !(admin || typist) ? 'True' : 'False',
        },
      });

      setRegisterB(registers.data);
      console.log(registers.data);
      getCodigos(registers.data.data.driverIncidenteDetails, setFontesB);
    }
    loadRegister(pathIdB);
    arrayImagens();
    fetchData();

    if (registerB.created !== '') {
      setLoading(false);
    }
  }, [
    pathId,
    authHeader,
    admin,
    registerB.created,
    geofi,
    publicGroup,
    tecEng,
    typist,
    arrayImagens,
  ]);

  function handleSameIncidents() {
    navigate(`/editar/duplicidades/${pathId}&${pathIdB}/`);
  }

  return (
    <>
      {loading ? (
        <div className={styles.loadingContainer}>
          <CircularProgress className={styles.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <Container className={styles.container}>
          {/* TÍTULO */}
          <Typography variant="h5">Análise de Duplicidade</Typography>
          <Divider />
          {/* TABELAS */}
          <Container className={styles.tablesComparison}>
            <Container className={styles.tableComparison}>
              {/* DETALHES DOS SINISTROS */}
              <div className={styles.tableRows}>
                {/* DETALHES DO SINISTRO A */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Detalhes do Incidente A</Typography>
                    </div>

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['ocorrido', 'criado']}
                      data={[
                        {
                          details: [
                            `${toDate(register.occurred_from)}`,
                            `${toDate(register.created)}`,
                          ],
                        },
                      ]}
                    />

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['endereço 1', 'endereço 2']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails['Endereço 1']}`,
                            `${register.data.driverIncidenteDetails['Endereço 2']}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['bairro', 'numero/referencia']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails.Bairro}`,
                            `${register.data.driverIncidenteDetails['Numero Referencia']}`,
                          ],
                        },
                      ]}
                    />
                    <Container className={styles.containerMap}>
                      <MapMarker
                        point={[
                          register.geom?.coordinates[1],
                          register.geom?.coordinates[0],
                        ]}
                        notDragabble
                      />
                    </Container>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['latitude', 'longitude']}
                      data={[
                        {
                          details: [
                            `${register.geom?.coordinates[1]}`,
                            `${register.geom?.coordinates[0]}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['iluminação', 'severidade']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails.Iluminação}`,
                            `${register.data.driverIncidenteDetails.Severidade}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['natureza', 'jurisdição']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails.Natureza}`,
                            `${register.data.driverIncidenteDetails.Jurisdição}`,
                          ],
                        },
                      ]}
                    />

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['tempo', 'uso do solo']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails.Tempo}`,
                            `${register.data.driverIncidenteDetails.Local}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['superfície da pista', 'controle de tráfego']}
                      data={[
                        {
                          details: [
                            `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                            `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                          ],
                        },
                      ]}
                    />
                  </Container>
                </div>
                {/* DETALHES DO SINISTRO B */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Detalhes do Incidente B</Typography>
                    </div>

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['ocorrido', 'criado']}
                      data={[
                        {
                          details: [
                            `${toDate(registerB.occurred_from)}`,
                            `${toDate(registerB.created)}`,
                          ],
                        },
                      ]}
                    />

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['endereço 1', 'endereço 2']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails['Endereço 1']}`,
                            `${registerB.data.driverIncidenteDetails['Endereço 2']}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['bairro', 'numero/referencia']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails.Bairro}`,
                            `${registerB.data.driverIncidenteDetails['Numero Referencia']}`,
                          ],
                        },
                      ]}
                    />
                    <Container className={styles.containerMap}>
                      <MapMarker
                        point={[
                          registerB.geom?.coordinates[1],
                          registerB.geom?.coordinates[0],
                        ]}
                        notDragabble
                      />
                    </Container>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['latitude', 'longitude']}
                      data={[
                        {
                          details: [
                            `${registerB.geom?.coordinates[1]}`,
                            `${registerB.geom?.coordinates[0]}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['iluminação', 'severidade']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails.Iluminação}`,
                            `${registerB.data.driverIncidenteDetails.Severidade}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['natureza', 'jurisdição']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails.Natureza}`,
                            `${registerB.data.driverIncidenteDetails.Jurisdição}`,
                          ],
                        },
                      ]}
                    />

                    <TableRegister
                      customStyles={customTableStyles}
                      title={['tempo', 'uso do solo']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails.Tempo}`,
                            `${registerB.data.driverIncidenteDetails.Local}`,
                          ],
                        },
                      ]}
                    />
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['superfície da pista', 'controle de tráfego']}
                      data={[
                        {
                          details: [
                            `${registerB.data.driverIncidenteDetails['Superfície da Pista']}`,
                            `${registerB.data.driverIncidenteDetails['Controle de Tráfego']}`,
                          ],
                        },
                      ]}
                    />
                  </Container>
                  
                </div>
              </div>
                      {/* FONTES */}
                  <div className={styles.tableRows}>
                    {/* FONTES A */}
                    <div>
                      <Container className={styles.root}>
                        <div className={styles.titleTable}>
                          <Typography variant="h5">Fontes do Registro</Typography>
                        </div>
                        <TableRegister
                          customStyles={customTableStyles}
                          title={['tipo', 'código']}
                        />
                        {fontes.map((fonte, index) => (
                          <TableRegister
                            customStyles={customTableStyles}
                            key={`fonte-A${index}`}
                            data={[
                              {
                                details: [fonte?.tipo, fonte?.codigo],
                              },
                            ]}
                          />
                        ))}
                      </Container>
                    </div>
                    {/* FONTES B */}
                    <div>
                      <Container className={styles.root}>
                        <div className={styles.titleTable}>
                          <Typography variant="h5">Fontes do Registro</Typography>
                        </div>
                        <TableRegister
                          customStyles={customTableStyles}
                          title={['tipo', 'código']}
                        />
                        {fontesB.map((fonte, index) => (
                          <TableRegister
                            customStyles={customTableStyles}
                            key={`fonte-B${index}`}
                            data={[
                              {
                                details: [fonte?.tipo, fonte?.codigo],
                              },
                            ]}
                          />
                        ))}
                      </Container>
                    </div>
                  </div>
              {/* VIAS */}
              <div className={styles.tableRows}>
                {/* VIAS A */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Vias</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={[
                        'nome',
                        'tipo de pavimento',
                        'faixas por sentido',
                        'alinhamento horizontal',
                      ]}
                    />
                    {register.data.driverVia.map((streets,index) => (
                      <TableRegister
                        customStyles={customTableStyles}
                        notDetails
                        key={`viaA1${index}${streets?.Nome}${Date.now()}`}
                        data={[
                          {
                            details: [
                              streets?.Nome,
                              streets?.['Tipo do Pavimento'],
                              streets?.['Faixa para Sentido'],
                              streets?.['Alinhamento Horizontal'],
                            ],
                          },
                        ]}
                        collapse={[
                          {
                            title: ['nome', 'sinalização horizontal'],
                            value: [streets?.Nome, streets?.['Sinalização Horizontal']],
                          },
                          {
                            title: ['sinalização vertical', 'alinhamento horizontal'],
                            value: [
                              streets?.['Sinalização Vertical'],
                              streets?.['Alinhamento Horizontal'],
                            ],
                          },
                          {
                            title: ['alinhamento vertical', 'obra de arte'],
                            value: [
                              streets?.['Alinhamento Vertical'],
                              `${toDate(streets?.['Obra de Arte'])}`,
                            ],
                          },
                          {
                            title: ['obras na pista', 'tipo da pista'],
                            value: [
                              `${toDate(streets?.['Obras na Pista'])}`,
                              streets?.['Tipo da Pista'],
                            ],
                          },
                          {
                            title: ['sinalização horizontal', 'sinalização vertical'],
                            value: [
                              streets?.['Sinalização Horizontal'],
                              streets?.['Sinalização Vertical'],
                            ],
                          },
                          {
                            title: ['condição da pista', 'condição da calçada'],
                            value: [
                              streets?.['Condição da Pista'],
                              streets?.['Condição da Calçada'],
                            ],
                          },
                          {
                            title: ['separação central'],
                            value: [streets?.['Separação Central']],
                          },
                        ]}
                      />
                    ))}
                  </Container>
                </div>
                {/* VIAS B */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Vias</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={[
                        'nome',
                        'tipo de pavimento',
                        'faixas por sentido',
                        'alinhamento horizontal',
                      ]}
                    />
                    {registerB.data.driverVia.map((streets,index) => (
                      <TableRegister
                        customStyles={customTableStyles}
                        notDetails
                        key={`ViaB1${index}${streets?.Nome}${Date.now()}`}
                        data={[
                          {
                            details: [
                              streets?.Nome,
                              streets?.['Tipo do Pavimento'],
                              streets?.['Faixa para Sentido'],
                              streets?.['Alinhamento Horizontal'],
                            ],
                          },
                        ]}
                        collapse={[
                          {
                            title: ['nome', 'sinalização horizontal'],
                            value: [streets?.Nome, streets?.['Sinalização Horizontal']],
                          },
                          {
                            title: ['sinalização vertical', 'alinhamento horizontal'],
                            value: [
                              streets?.['Sinalização Vertical'],
                              streets?.['Alinhamento Horizontal'],
                            ],
                          },
                          {
                            title: ['alinhamento vertical', 'obra de arte'],
                            value: [
                              streets?.['Alinhamento Vertical'],
                              `${toDate(streets?.['Obra de Arte'])}`,
                            ],
                          },
                          {
                            title: ['obras na pista', 'tipo da pista'],
                            value: [
                              `${toDate(streets?.['Obras na Pista'])}`,
                              streets?.['Tipo da Pista'],
                            ],
                          },
                          {
                            title: ['sinalização horizontal', 'sinalização vertical'],
                            value: [
                              streets?.['Sinalização Horizontal'],
                              streets?.['Sinalização Vertical'],
                            ],
                          },
                          {
                            title: ['condição da pista', 'condição da calçada'],
                            value: [
                              streets?.['Condição da Pista'],
                              streets?.['Condição da Calçada'],
                            ],
                          },
                          {
                            title: ['separação central'],
                            value: [streets?.['Separação Central']],
                          },
                        ]}
                      />
                    ))}
                  </Container>
                </div>
              </div>
              {/* ENVOLVIDOS */}
              <div className={styles.tableRows}>
                {/* ENVOLVIDOS A */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Envolvidos</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={
                        admin || typist
                          ? ['tipo de envolvido', 'gênero', 'idade', 'gravidade da lesão']
                          : ['tipo de pessoa', 'gravidade', 'gênero', 'idade']
                      }
                    />
                    {register.data.driverVitima.map((victims,index) => (
                      <TableRegister
                        customStyles={customTableStyles}
                        notDetails
                        key={`vitimaA3${index}${victims?.Idade}${
                          victims?.['Número da CNH']
                        }${Date.now()}`}
                        data={
                          admin || typist
                            ? [
                                {
                                  details: [
                                    victims?.['Tipo de Pessoa'],
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade === '-1'
                                      ? 'Não informado'
                                      : victims.Idade,
                                    victims?.['Gravidade da Lesão'],
                                  ],
                                },
                              ]
                            : [
                                {
                                  details: [
                                    victims?.['Tipo de Pessoa'],
                                    victims?.['Gravidade da Lesão'],
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                  ],
                                },
                              ]
                        }
                        collapse={
                          admin || typist
                            ? [
                                {
                                  title: ['Idade', 'Gênero'],
                                  value: [
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                    victims?.Sexo,
                                  ],
                                },
                                {
                                  title: ['Nome', ' Número da CNH '],
                                  value: [victims?.Nome, victims?.['Número da CNH']],
                                },
                                {
                                  title: ['Usava Cinto ou Capacete', ' Data de Alta '],
                                  value: [
                                    victims?.['Usava Cinto ou Capacete'],
                                    `${toDate(victims?.['Data de Alta'])}`,
                                  ],
                                },
                                {
                                  title: ['Data de Internação', 'Categoria do Condutor'],
                                  value: [
                                    `${toDate(victims?.['Data de Internação'])}`,
                                    victims?.['Categoria do Condutor'],
                                  ],
                                },
                                {
                                  title: ['Exame de alcoolemia', 'Dosagem'],
                                  value: [
                                    victims?.['Exame de alcoolemia'],
                                    victims?.Dosagem,
                                  ],
                                },
                                {
                                  title: ['Situação do Condutor', 'Encaminhamento'],
                                  value: [
                                    victims?.['Situação do Condutor'],
                                    victims?.Encaminhamento,
                                  ],
                                },
                                {
                                  title: ['Posição do passageiro', 'Evolução de caso'],
                                  value: [
                                    victims?.['Posição do Passageiro'],
                                    victims?.['Evolução de Caso'],
                                  ],
                                },
                                {
                                  title: ['Tipo de Morte', 'Custo Geral'],
                                  value: [
                                    victims?.['Tipo de Morte'],
                                    victims?.['Custo Geral'],
                                  ],
                                },
                                {
                                  title: [
                                    'Número do cartão de saúde cidadão',
                                    'Início de Reabilitação',
                                  ],
                                  value: [
                                    victims?.['Número do cartão de saúde cidadão'],
                                    `${toDate(victims?.['Início de Reabilitação'])}`,
                                  ],
                                },
                                {
                                  title: ['Fim da Reabilitação', 'Data do Óbito'],
                                  value: [
                                    `${toDate(victims?.['Fim da Reabilitação'])}`,
                                    `${toDate(victims?.['Data da Óbito'])}`,
                                  ],
                                },
                                {
                                  title: ['Procedimentos realizados', ' Observações '],
                                  value: [
                                    victims?.['Procedimentos realizados'],
                                    victims?.Observações,
                                  ],
                                },
                                {
                                  title: ['Lesões', 'Tipo de Envolvido'],
                                  value: [
                                    victims.Lesões?.join(', '),
                                    victims?.['Tipo de Pessoa'],
                                  ],
                                },
                                {
                                  title: ['Gravidade da Lesão', 'Código Veículo'],
                                  value: [
                                    victims?.['Gravidade da Lesão'],
                                    victims?.['Código Veículo'],
                                  ],
                                },
                                {
                                  title: ['Tipo Documento', 'Número Documento'],
                                  value: [
                                    victims?.['Tipo Documento'],
                                    victims?.['Número Documento'],
                                  ],
                                },
                                {
                                  title: ['Data de Nascimento'],
                                  value: [`${toDate(victims?.['Data de Nascimento'])}`],
                                },
                              ]
                            : [
                                {
                                  title: ['Gênero', 'Idade'],
                                  value: [
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                  ],
                                },
                                {
                                  title: [
                                    'Usava cinto ou capacete',
                                    'Exame de alcoolemia',
                                  ],
                                  value: [
                                    victims?.['Usava Cinto ou Capacete'],
                                    victims?.['Exame de alcoolemia'],
                                  ],
                                },
                                {
                                  title: ['Dosagem', 'Gravidade da Lesão'],
                                  value: [
                                    victims?.Dosagem,
                                    victims?.['Gravidade da Lesão'],
                                  ],
                                },
                                {
                                  title: ['Código do veículo', 'Tipo de pessoa'],
                                  value: [
                                    victims?.['Código Veículo'],
                                    victims?.['Tipo de Pessoa'],
                                  ],
                                },
                              ]
                        }
                      />
                    ))}
                  </Container>
                </div>
                {/* ENVOLVIDOS B */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Envolvidos</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={
                        admin || typist
                          ? ['tipo de envolvido', 'gênero', 'idade', 'gravidade da lesão']
                          : ['tipo de pessoa', 'gravidade', 'gênero', 'idade']
                      }
                    />
                    {registerB.data.driverVitima.map((victims,index) => (
                      <TableRegister
                        customStyles={customTableStyles}
                        notDetails
                        key={`vitimasB3${index}${victims?.Idade}${
                          victims?.['Número da CNH']
                        }${Date.now()}`}
                        data={
                          admin || typist
                            ? [
                                {
                                  details: [
                                    victims?.['Tipo de Pessoa'],
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade === '-1'
                                      ? 'Não informado'
                                      : victims.Idade,
                                    victims?.['Gravidade da Lesão'],
                                  ],
                                },
                              ]
                            : [
                                {
                                  details: [
                                    victims?.['Tipo de Pessoa'],
                                    victims?.['Gravidade da Lesão'],
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                  ],
                                },
                              ]
                        }
                        collapse={
                          admin || typist
                            ? [
                                {
                                  title: ['Idade', 'Gênero'],
                                  value: [
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                    victims?.Sexo,
                                  ],
                                },
                                {
                                  title: ['Nome', ' Número da CNH '],
                                  value: [victims?.Nome, victims?.['Número da CNH']],
                                },
                                {
                                  title: ['Usava Cinto ou Capacete', ' Data de Alta '],
                                  value: [
                                    victims?.['Usava Cinto ou Capacete'],
                                    `${toDate(victims?.['Data de Alta'])}`,
                                  ],
                                },
                                {
                                  title: ['Data de Internação', 'Categoria do Condutor'],
                                  value: [
                                    `${toDate(victims?.['Data de Internação'])}`,
                                    victims?.['Categoria do Condutor'],
                                  ],
                                },
                                {
                                  title: ['Exame de alcoolemia', 'Dosagem'],
                                  value: [
                                    victims?.['Exame de alcoolemia'],
                                    victims?.Dosagem,
                                  ],
                                },
                                {
                                  title: ['Situação do Condutor', 'Encaminhamento'],
                                  value: [
                                    victims?.['Situação do Condutor'],
                                    victims?.Encaminhamento,
                                  ],
                                },
                                {
                                  title: ['Posição do passageiro', 'Evolução de caso'],
                                  value: [
                                    victims?.['Posição do Passageiro'],
                                    victims?.['Evolução de Caso'],
                                  ],
                                },
                                {
                                  title: ['Tipo de Morte', 'Custo Geral'],
                                  value: [
                                    victims?.['Tipo de Morte'],
                                    victims?.['Custo Geral'],
                                  ],
                                },
                                {
                                  title: [
                                    'Número do cartão de saúde cidadão',
                                    'Início de Reabilitação',
                                  ],
                                  value: [
                                    victims?.['Número do cartão de saúde cidadão'],
                                    `${toDate(victims?.['Início de Reabilitação'])}`,
                                  ],
                                },
                                {
                                  title: ['Fim da Reabilitação', 'Data do Óbito'],
                                  value: [
                                    `${toDate(victims?.['Fim da Reabilitação'])}`,
                                    `${toDate(victims?.['Data da Óbito'])}`,
                                  ],
                                },
                                {
                                  title: ['Procedimentos realizados', ' Observações '],
                                  value: [
                                    victims?.['Procedimentos realizados'],
                                    victims?.Observações,
                                  ],
                                },
                                {
                                  title: ['Lesões', 'Tipo de Envolvido'],
                                  value: [
                                    victims.Lesões?.join(', '),
                                    victims?.['Tipo de Pessoa'],
                                  ],
                                },
                                {
                                  title: ['Gravidade da Lesão', 'Código Veículo'],
                                  value: [
                                    victims?.['Gravidade da Lesão'],
                                    victims?.['Código Veículo'],
                                  ],
                                },
                                {
                                  title: ['Tipo Documento', 'Número Documento'],
                                  value: [
                                    victims?.['Tipo Documento'],
                                    victims?.['Número Documento'],
                                  ],
                                },
                                {
                                  title: ['Data de Nascimento'],
                                  value: [`${toDate(victims?.['Data de Nascimento'])}`],
                                },
                              ]
                            : [
                                {
                                  title: ['Gênero', 'Idade'],
                                  value: [
                                    victims?.Sexo,
                                    typeof victims?.Idade === 'number' &&
                                    victims.Idade < 0
                                      ? 'Não informado'
                                      : victims.Idade,
                                  ],
                                },
                                {
                                  title: [
                                    'Usava cinto ou capacete',
                                    'Exame de alcoolemia',
                                  ],
                                  value: [
                                    victims?.['Usava Cinto ou Capacete'],
                                    victims?.['Exame de alcoolemia'],
                                  ],
                                },
                                {
                                  title: ['Dosagem', 'Gravidade da Lesão'],
                                  value: [
                                    victims?.Dosagem,
                                    victims?.['Gravidade da Lesão'],
                                  ],
                                },
                                {
                                  title: ['Código do veículo', 'Tipo de pessoa'],
                                  value: [
                                    victims?.['Código Veículo'],
                                    victims?.['Tipo de Pessoa'],
                                  ],
                                },
                              ]
                        }
                      />
                    ))}
                  </Container>
                </div>
              </div>
              {/* VEÍCULOS */}
              <div className={styles.tableRows}>
                {/* VEICULOS A */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Veículos</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['tipo veículo', 'marca', 'categoria', 'espécie']}
                    />
                    {register.data.driverVeiculo.map(
                      (vehicle: Vehicle, index: number) => (
                        <TableRegister
                          customStyles={customTableStyles}
                          notDetails
                          key={`veiculoA5${index}${vehicle?.Placa}${Date.now()}`}
                          data={[
                            {
                              details: [
                                vehicle?.['Tipo Veículo'],
                                vehicle?.Marca,
                                vehicle?.Categoria,
                                vehicle?.['Espécie'],
                              ],
                            },
                          ]}
                          collapse={
                            admin || typist
                              ? [
                                  {
                                    title: [' Tipo Veículo ', 'Placa'],
                                    value: [vehicle?.['Tipo Veículo'], vehicle?.Placa],
                                  },
                                  {
                                    title: ['Marca', 'Número do Ônibus'],
                                    value: [
                                      vehicle?.Marca,
                                      vehicle?.['Número do Ônibus'],
                                    ],
                                  },
                                  {
                                    title: ['Linha do Ônibus', 'Cor'],
                                    value: [vehicle?.['Linha do Ônibus'], vehicle?.Cor],
                                  },
                                  {
                                    title: ['Ano Fabricação', 'Espécie'],
                                    value: [
                                      vehicle?.['Ano Fabricação'],
                                      vehicle?.Espécie,
                                    ],
                                  },
                                  {
                                    title: ['Categoria', 'Legalizado'],
                                    value: [vehicle?.Categoria, vehicle?.Legalizado],
                                  },
                                  {
                                    title: ['Via de acesso', 'Manobra'],
                                    value: [vehicle['Via de Acesso'], vehicle?.Manobra],
                                  },
                                  {
                                    title: ['Outra manobra', 'Danificado'],
                                    value: [
                                      vehicle?.['Outra manobra'] || 'Não informado',
                                      vehicle.Danificado,
                                    ],
                                  },
                                  {
                                    title: ['Categoria de Dano', 'Estrutura'],
                                    value: vehicle['Formulario de Dano']
                                      ? [
                                          vehicle?.['Formulario de Dano']?.DamageType,
                                          vehicle?.['Formulario de Dano']?.structure,
                                        ]
                                      : ['Não Informado', 'Não Informado'],
                                  },
                                  {
                                    title: ['Aluguel', 'Código Veículo'],
                                    value: [vehicle?.Aluguel, vehicle['Código Veículo']],
                                  },
                                ]
                              : [
                                  {
                                    title: [' Tipo Veículo ', 'Marca'],
                                    value: [vehicle?.['Tipo Veículo'], vehicle?.Marca],
                                  },
                                  {
                                    title: ['Categoria', 'Espécie'],
                                    value: [vehicle?.Categoria, vehicle?.Espécie],
                                  },
                                  {
                                    title: ['Código do veículo'],
                                    value: [vehicle?.['Código Veículo']],
                                  },
                                ]
                          }
                          damageForm={
                            vehicle['Formulario de Dano']
                              ? vehicle['Formulario de Dano'].DamageFormDetails
                              : undefined
                          }
                        />
                      ),
                    )}
                  </Container>
                </div>
                {/* VEICULOS B */}
                <div>
                  <Container className={styles.root}>
                    <div className={styles.titleTable}>
                      <Typography variant="h5">Veículos</Typography>
                    </div>
                    <TableRegister
                      customStyles={customTableStyles}
                      title={['tipo veículo', 'marca', 'categoria', 'espécie']}
                    />
                    {registerB.data.driverVeiculo.map(
                      (vehicle: Vehicle, index: number) => (
                        <TableRegister
                          customStyles={customTableStyles}
                          notDetails
                          key={`veiculoB5${index}${vehicle?.Placa}${Date.now()}`}
                          data={[
                            {
                              details: [
                                vehicle?.['Tipo Veículo'],
                                vehicle?.Marca,
                                vehicle?.Categoria,
                                vehicle?.['Espécie'],
                              ],
                            },
                          ]}
                          collapse={
                            admin || typist
                              ? [
                                  {
                                    title: [' Tipo Veículo ', 'Placa'],
                                    value: [vehicle?.['Tipo Veículo'], vehicle?.Placa],
                                  },
                                  {
                                    title: ['Marca', 'Número do Ônibus'],
                                    value: [
                                      vehicle?.Marca,
                                      vehicle?.['Número do Ônibus'],
                                    ],
                                  },
                                  {
                                    title: ['Linha do Ônibus', 'Cor'],
                                    value: [vehicle?.['Linha do Ônibus'], vehicle?.Cor],
                                  },
                                  {
                                    title: ['Ano Fabricação', 'Espécie'],
                                    value: [
                                      vehicle?.['Ano Fabricação'],
                                      vehicle?.Espécie,
                                    ],
                                  },
                                  {
                                    title: ['Categoria', 'Legalizado'],
                                    value: [vehicle?.Categoria, vehicle?.Legalizado],
                                  },
                                  {
                                    title: ['Via de acesso', 'Manobra'],
                                    value: [vehicle['Via de Acesso'], vehicle?.Manobra],
                                  },
                                  {
                                    title: ['Outra manobra', 'Danificado'],
                                    value: [
                                      vehicle?.['Outra manobra'] || 'Não informado',
                                      vehicle.Danificado,
                                    ],
                                  },
                                  {
                                    title: ['Categoria de Dano', 'Estrutura'],
                                    value: vehicle['Formulario de Dano']
                                      ? [
                                          vehicle?.['Formulario de Dano']?.DamageType,
                                          vehicle?.['Formulario de Dano']?.structure,
                                        ]
                                      : ['Não Informado', 'Não Informado'],
                                  },
                                  {
                                    title: ['Aluguel', 'Código Veículo'],
                                    value: [vehicle?.Aluguel, vehicle['Código Veículo']],
                                  },
                                ]
                              : [
                                  {
                                    title: [' Tipo Veículo ', 'Marca'],
                                    value: [vehicle?.['Tipo Veículo'], vehicle?.Marca],
                                  },
                                  {
                                    title: ['Categoria', 'Espécie'],
                                    value: [vehicle?.Categoria, vehicle?.Espécie],
                                  },
                                  {
                                    title: ['Código do veículo'],
                                    value: [vehicle?.['Código Veículo']],
                                  },
                                ]
                          }
                          damageForm={
                            vehicle['Formulario de Dano']
                              ? vehicle['Formulario de Dano'].DamageFormDetails
                              : undefined
                          }
                        />
                      ),
                    )}
                  </Container>
                </div>
              </div>

              <Container className={styles.small}>
                {register.data.driverVia.map((streets) => (
                  <>
                    <Button
                      key={`viaB2${streets?.Nome}${Date.now()}`}
                      onClick={handleOpen}
                      variant="outlined"
                      style={{ width: '100%', margin: '5% 0 2% 0' }}
                    >
                      Ver mais
                    </Button>
                    <TableRegister title={['nome']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.Nome],
                        },
                      ]}
                    />

                    <TableRegister title={['tipo de pavimento']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Tipo do Pavimento']],
                        },
                      ]}
                    />
                    <TableRegister title={['faixas por sentido']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Faixa para Sentido']],
                        },
                      ]}
                    />
                    <TableRegister title={['alinhamento horizontal']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Alinhamento Horizontal']],
                        },
                      ]}
                    />
                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      className={styles.modal}
                      open={open}
                      onClose={handleClose}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={open}>
                        <div className={styles.paper}>
                          <div className={styles.header}>Nome</div>
                          <p>{streets?.Nome}</p>
                          <div className={styles.header}>Sinalização Horizontal</div>
                          <p>{streets?.['Sinalização Horizontal']}</p>
                          <div className={styles.header}>Sinalização Vertical</div>
                          <p>{streets?.['Sinalização Vertical']}</p>
                          <div className={styles.header}>Alinhamento Horizontal</div>
                          <p>{streets?.['Alinhamento Horizontal']}</p>
                          <div className={styles.header}>Alinhamento Vertical</div>
                          <p>{streets?.['Alinhamento Vertical']}</p>
                          <div className={styles.header}>Obra de Arte</div>
                          <p>{streets?.['Obra de Arte']}</p>
                          <div className={styles.header}>Obras na Pista</div>
                          <p>{streets?.['Obras na Pista']}</p>
                          <div className={styles.header}>Tipo da Pista</div>
                          <p>{streets?.['Tipo da Pista']}</p>
                          <div className={styles.header}>Tipo do Pavimento</div>
                          <p>{streets?.['Tipo do Pavimento']}</p>
                          <div className={styles.header}>Faixa para Sentido</div>
                          <p>{streets?.['Faixa para Sentido']}</p>
                          <div className={styles.header}>Condição da Pista</div>
                          <p>{streets?.['Condição da Pista']}</p>
                          <div className={styles.header}>Condição da Calçada</div>
                          <p>{streets?.['Condição da Calçada']}</p>
                          <div className={styles.header}>Separação Central</div>
                          <p>{streets?.['Separação Central']}</p>
                        </div>
                      </Fade>
                    </Modal>
                  </>
                ))}
              </Container>
              {/* ENVOLVIDOS */}

              {/* VEÍCULOS */}

              {/* SMALL */}
              <Container className={styles.small}>
                <TableRegister
                  customStyles={customTableStyles}
                  title={['ocorrido']}
                  data={[
                    {
                      details: [`${toDate(register?.occurred_from)}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['criado']}
                  data={[
                    {
                      details: [`${toDate(register?.created)}`],
                    },
                  ]}
                />

                <TableRegister
                  customStyles={customTableStyles}
                  title={['endereço 1']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 1']}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['endereço 2']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 2']}`],
                    },
                  ]}
                />

                {/* MAPA */}
                <Container className={styles.containerMap}>
                  <MapMarker
                    point={[register.geom.coordinates[1], register.geom.coordinates[0]]}
                    notDragabble
                  />
                </Container>

                <TableRegister
                  customStyles={customTableStyles}
                  title={['latitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[1]}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['longitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[0]}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['iluminação']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Iluminação}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['severidade']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Severidade}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['natureza']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Natureza}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['jurisdição']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Jurisdição}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['tempo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Tempo}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['uso do solo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Local}`],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['superfície da pista']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  customStyles={customTableStyles}
                  title={['controle de tráfego']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                      ],
                    },
                  ]}
                />
              </Container>
            </Container>

            {/* TABELA B */}

            {/* BOTÕES */}
            <div className={styles.buttonsContainer}>
              <Button
                className={styles.buttons}
                style={{ backgroundColor: Colors.main }}
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                onClick={differentIncidents}
              >
                Sinistros diferentes
              </Button>

              <Button
                className={styles.buttons}
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                style={{ backgroundColor: '#C59054' }}
                onClick={handleSameIncidents}
              >
                Sinistros iguais
              </Button>

              <Button
                className={styles.buttons}
                variant="outlined"
                color="secondary"
                disabled={loading}
                style={{ backgroundColor: 'white' }}
                onClick={() => navigate('/duplicidades')}
              >
                Cancelar
              </Button>
            </div>
          </Container>

          <ShowSnackbar
            open={snackBar.open}
            message={snackBar.message}
            setSnackbar={setSnackbar}
          />

          <DialogWarnActionsDuplicity
            dialogActions={dialogAction}
            setDialog={setDialogAction}
          />
        </Container>
      )}
    </>
  );
};

export default AnalyzeDuplicity;
